import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
  Select,
  MenuItem,
  IconButton,
  Menu,
  useTheme as useMuiTheme,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import { useLanguage } from "../contexts/LanguageContext";
import { useTheme } from "../contexts/ThemeContext";
import { locales, formatMessage } from "../locales";

function Navigation() {
  const { locale, messages, setLocale } = useLanguage();
  const { mode, toggleTheme } = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useMuiTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleLanguageChange = (event) => {
    setLocale(event.target.value);
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const menuItems = [
    { to: "/debate", label: "navigation.debate" },
    { to: "/read", label: "navigation.read" },
    { to: "/support", label: "navigation.support" },
    { to: "/about", label: "navigation.about" },
  ];

  return (
    <AppBar position="static">
      <Container maxWidth="lg">
        <Toolbar disableGutters>
          <Box
            component={RouterLink}
            to="/"
            sx={{
              flexGrow: 1,
              textDecoration: "none",
              color: "inherit",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box
              component="img"
              src="/images/logo.png"
              alt="Open Creed"
              sx={{
                height: 40,
                mr: 1,
              }}
            />
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                letterSpacing: 1,
                color: "inherit",
                display: { xs: "none", sm: "block" },
              }}
            >
              Open Creed
            </Typography>
          </Box>

          {isMobile ? (
            <>
              <IconButton color="inherit" onClick={toggleTheme} sx={{ mr: 1 }}>
                {mode === "dark" ? <Brightness7Icon /> : <Brightness4Icon />}
              </IconButton>
              <Select
                value={locale}
                onChange={handleLanguageChange}
                size="small"
                sx={{
                  color: "inherit",
                  mr: 1,
                  ".MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(255, 255, 255, 0.23)",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(255, 255, 255, 0.23)",
                  },
                  ".MuiSvgIcon-root": { color: "inherit" },
                }}
              >
                {Object.entries(locales).map(([code, { name }]) => (
                  <MenuItem key={code} value={code}>
                    {name}
                  </MenuItem>
                ))}
              </Select>
              <IconButton
                color="inherit"
                aria-label="menu"
                onClick={handleMenuOpen}
                edge="end"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
              >
                {menuItems.map((item) => (
                  <MenuItem
                    key={item.to}
                    component={RouterLink}
                    to={item.to}
                    onClick={handleMenuClose}
                  >
                    {formatMessage(messages, item.label)}
                  </MenuItem>
                ))}
              </Menu>
            </>
          ) : (
            <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
              {menuItems.map((item) => (
                <Button
                  key={item.to}
                  color="inherit"
                  component={RouterLink}
                  to={item.to}
                >
                  {formatMessage(messages, item.label)}
                </Button>
              ))}
              <IconButton color="inherit" onClick={toggleTheme}>
                {mode === "dark" ? <Brightness7Icon /> : <Brightness4Icon />}
              </IconButton>
              <Select
                value={locale}
                onChange={handleLanguageChange}
                size="small"
                sx={{
                  color: "inherit",
                  ".MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(255, 255, 255, 0.23)",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(255, 255, 255, 0.23)",
                  },
                  ".MuiSvgIcon-root": { color: "inherit" },
                }}
              >
                {Object.entries(locales).map(([code, { name }]) => (
                  <MenuItem key={code} value={code}>
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default Navigation;
